export const SET_MENU_OPTION = "SET_MENU_OPTION";
export const DIALOG_OPEN = "DIALOG_OPEN";

export const ROUTER_PAYLOAD_UPDATER = "ROUTER_PAYLOAD_UPDATER";